import { Sparkles, Zap, HeartHandshake, ListChecks } from "lucide-react";

export function howToContent(isLender) {
  return [
    {
      icon: Sparkles,
      title: "What it is 🍭",
      body: isLender
        ? "My Pocket Lender lets your realtors send polished, on-brand pre-approvals & loan summaries themselves — so you're not the bottleneck anymore. You stay in control; they do the busywork."
        : "My Pocket Lender lets you send gorgeous, lender-branded pre-approvals & loan summaries yourself — right from your phone, in seconds. No more \"let me call my lender\" moments.",
    },
    {
      icon: HeartHandshake,
      title: "Why you need it",
      body: isLender
        ? "No more 9pm \"can you send a pre-approval?\" texts. Fewer interruptions, faster closings, happier realtors — and you look like the hero. 🦸"
        : "Win offers faster and wow your buyers. Everything's ready the moment you need it — no waiting, no missed beats. Your thumbs do the heavy lifting. 👍",
    },
    {
      icon: ListChecks,
      title: "How to use it",
      steps: isLender
        ? [
            "Set up your Lender Profile — add your logo, headshot, NMLS & contact info (or upload a loan summary PDF and we'll auto-fill it).",
            "Invite or approve your realtors from the Agents tab.",
            "Load a client with their buying power (or autofill from a loan summary PDF) and attach their loan estimate.",
            "Set each client's status: Preapproved → Fully Approved.",
            "Your realtors take it from there — sending pre-approvals themselves. You get an alert every time.",
          ]
        : [
            "Add your lenders in the My Lenders tab — star your go-to and invite any that aren't on the app yet.",
            "Set up your Profile so your buyers know exactly who they're working with.",
            "When your lender loads a client, they show up in My Clients.",
            "Tap a client, punch in the offer price, property taxes & HOA, then hit Generate.",
            "Download the PDF, email it, or copy the share link and text it — done in seconds. 🚀",
          ],
    },
  ];
}

export default function HowToUse({ isLender }) {
  const items = howToContent(isLender);
  return (
    <div className="max-w-2xl space-y-4" data-testid="how-to-use">
      {items.map((it, i) => {
        const Icon = it.icon;
        return (
          <div
            key={i}
            className="bg-[#141414]/80 backdrop-blur-xl border border-white/10 shadow-2xl shadow-black/40 rounded-2xl p-6"
          >
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-xl bg-[#ff3b30]/15 text-[#ff3b30] flex items-center justify-center shrink-0">
                <Icon className="h-5 w-5" />
              </div>
              <h3 className="font-display text-xl tracking-tight">{it.title}</h3>
            </div>
            {it.body && <p className="text-sm text-white/65 mt-4 leading-relaxed">{it.body}</p>}
            {it.steps && (
              <ol className="mt-4 space-y-3">
                {it.steps.map((s, idx) => (
                  <li key={idx} className="flex gap-3 text-sm text-white/70 leading-relaxed">
                    <span className="h-6 w-6 rounded-full bg-[#ff3b30] text-white text-xs font-bold flex items-center justify-center shrink-0">
                      {idx + 1}
                    </span>
                    <span className="pt-0.5">{s}</span>
                  </li>
                ))}
              </ol>
            )}
          </div>
        );
      })}
    </div>
  );
}
